// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3OgsC","buttons":"RemoveExpirationActionButtons_buttons__2hB6g"};